import RegisterTakeTestAuth from 'modules/auth/RegisterTakeTest'

const RegisterTakeTest = () => {
  return <RegisterTakeTestAuth />
};

export default RegisterTakeTest;